/**
 * Admin invitations API layer (P1 Tier-A, users.invite_admin). Typed call to
 * the SHIPPED POST /admin/invitations. No list endpoint exists (the token is
 * delivered only via the outbox email), so this surface is action-only. The
 * 5 system roles are the only inviteable targets (the backend rejects others);
 * language is RU/KY only (the email template set). No backend routes added.
 */
import { apiClient } from "@/lib/api-client";

export const SYSTEM_ROLE_SLUGS = [
  "super_admin", "content_moderator", "support_agent", "finance_admin", "data_entry",
] as const;
export type SystemRoleSlug = (typeof SYSTEM_ROLE_SLUGS)[number];

export type InviteLanguage = "ru" | "ky";

export interface InvitationCreate {
  email: string;
  role_slug: SystemRoleSlug;
  language: InviteLanguage;
}
export interface InvitationResponse {
  invitation_id: string;
  expires_at: string;
}

export function createInvitation(body: InvitationCreate): Promise<InvitationResponse> {
  // POST auto-attaches the JWT + Idempotency-Key (REQ-ADD-§6.3-A).
  return apiClient.post<InvitationResponse, InvitationCreate>("/admin/invitations", body);
}
